import { parse, stringify } from "query-string";

export const parseQueryString = querystring =>
  parse(querystring.replace(/^\?/, ""));

export const getPassageId = ({ location }) => {
  const queryParams = parseQueryString(location.search);

  return queryParams.passageId;
};

export const chapterPath = ({ bibleId, chapterId, passageId, location }) => {
  let queryParams = {};
  if (location) {
    queryParams = parseQueryString(location.search);
  }

  const { passageId: removedPassageId, ...restOfParams } = queryParams;
  const newParams = {
    ...restOfParams,
    passageId
  };
  const path = `/bible/${bibleId}/${chapterId}?${stringify(newParams)}`;
  return path;
};

export const removeAllParallels = ({ location }) => {
  const { parallels, ...queryParams } = parseQueryString(location.search);
  return `${location.pathname}?${stringify(queryParams)}`;
};

export const removeParallel = ({ parallelIndex, location }) => {
  const queryParams = parseQueryString(location.search);
  const parallels = queryParams.parallels
    ? queryParams.parallels.split(",")
    : [];

  const newParallels = [
    ...parallels.slice(0, parallelIndex),
    ...parallels.slice(parallelIndex + 1, parallels.length)
  ];
  const newParams = {
    ...queryParams,
    parallels: newParallels.length ? newParallels.join(",") : undefined
  };
  const path = `${location.pathname}?${stringify(newParams)}`;
  return path;
};

export const addParallel = ({ parallelId, location }) => {
  const queryParams = parseQueryString(location.search);
  const parallels = queryParams.parallels
    ? queryParams.parallels.split(",")
    : [];

  const newParallels = [...parallels, parallelId];
  const newParams = {
    ...queryParams,
    parallels: newParallels.length ? newParallels.join(",") : undefined
  };
  const path = `${location.pathname}?${stringify(newParams)}`;
  return path;
};

export const getParallels = querystring => {
  const parallelsStr = parseQueryString(querystring).parallels;
  if (!parallelsStr) {
    return [];
  }
  return parallelsStr.split(",");
};

export const updatePagination = ({ location, offset, limit }) => {
  const queryParams = parseQueryString(location.search);
  const newParams = {
    ...queryParams,
    offset,
    limit
  };
  return `${location.pathname}?${stringify(newParams)}`;
};

export const changeBible = ({ location, match, bibleId, parallelIndex }) => {
  const { params } = match;
  if (parallelIndex === undefined || parallelIndex === null) {
    const newPath = `/bible/${bibleId}/${params.chapterId}`;
    return `${newPath}${location.search}`;
  }
  const queryParams = parseQueryString(location.search);
  const parallels = queryParams.parallels
    ? queryParams.parallels.split(",")
    : [];
  const newParams = {
    ...queryParams,
    parallels: [
      ...parallels.slice(0, parallelIndex),
      bibleId,
      ...parallels.slice(parallelIndex + 1, parallels.length)
    ].join(",")
  };
  return `${match.url}?${stringify(newParams)}`;
};
